import RoutesComp from "./Component/Routing/RoutesComp";

function App() {
  return (
    <RoutesComp />
  );
}

export default App;
